import { combineReducers } from '@reduxjs/toolkit';

import {
  initialState as initialSelectedOrderState,
  selectedOrderSlice,
} from './selected-order/selected-order.slice';

export const initialOrderState = {
  selectedOrder: initialSelectedOrderState,
};

export const orderReducer = combineReducers({
  selectedOrder: selectedOrderSlice.reducer,
});
